import { VenturesSection } from "@/components/VenturesSection";

/**
 * The bookable places, on their own page. Each card carries its own booking
 * action and rates; the venture detail pages stay at /ventures/:slug.
 */
export default function Stay() {
  return (
    <main className="bg-cream text-ink no-x pt-[76px]" data-testid="stay-page">
      <VenturesSection />
    </main>
  );
}
